<template>
  <div v-if="current">
    <div class="row">
      <div class="col-md-6">
        <v-btn color="primary" @click="register()">Nova CDO</v-btn>
      </div>
      <div class="col-md-6">&nbsp;</div>
    </div>
    <v-simple-table>
      <thead>
        <tr>
          <th>POP</th>
          <th>Código</th>
          <th>Nome</th>
          <th>CTO máximo</th>
          <th>CTO ativas</th>
          <th>Topologia</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.pop.codigo }}</td>
          <td>{{ item.codigo }}</td>
          <td>{{ item.nome }}</td>
          <td>{{ item.ctoMax }}</td>
          <td>{{ item.ctoDone }}</td>
          <td>{{ item.topologia | formatTopologia}}</td>
          <td>
            <v-btn small color="primary" @click="view(item.id)">detalhes</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/cdo", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    view: function(id) {
      this.$router.push({ path: `/cdo/${id}` });
    },
    register: function() {
      router.push({ path: "/cdo/0" });
    }
  },
  filters: {
    formatTopologia: function (tipo) {
      var ret = "desconhecida";
      if (tipo == 1) {
        ret = "Cascata";
      } else if (tipo == 2) {
        ret = "Estrela";
      }
      return ret;
    }
  }
};
</script>